import type React from 'react';
import { createElement } from 'react';

import type { DropdownProps } from '@hivebrite/design-system/Dropdown';

import TopicMemberRequestContainer from 'hb-react/shared/apps/Topics/containers/TopicMemberRequestContainer/index';
import type {
  Following,
  Topic,
  TopicHeaderProps,
} from 'hb-react/shared/apps/Topics/containers/TopicShowContainer/types';
import { getMemberActionsButton } from 'hb-react/shared/apps/Topics/containers/TopicShowContainer/utils/getMemberActions';

export type DropdownData = Pick<
  DropdownProps,
  'items' | 'title' | 'dataTestId' | 'onClickItem'
>;

interface GroupHeaderButton {
  JoinButton?: React.ReactNode;
  threeDotsButtonData?: DropdownData;
}

export interface GroupHeaderButtonsProperties {
  following: Following;
  isPO: boolean;
  unfollowTopic: TopicHeaderProps['unfollowTopic'];
  updateSettings: TopicHeaderProps['updateSettings'];
  topic: Topic;
}

export const getGroupHeaderButtons = ({
  following,
  isPO,
  unfollowTopic,
  updateSettings,
  topic,
}: GroupHeaderButtonsProperties): GroupHeaderButton => {
  if (following) {
    const memberActionsButton = getMemberActionsButton({
      following,
      unfollowTopic,
      updateSettings,
      topicClosed: topic?.closed,
    });

    return {
      JoinButton: undefined,
      threeDotsButtonData: memberActionsButton,
    };
  }

  if (topic?.closed || isPO) {
    return {
      JoinButton: undefined,
      threeDotsButtonData: undefined,
    };
  }

  return {
    // JoinButton is ReactNode because of the complexity to rework the JoinButton (Redux)
    JoinButton: createElement(TopicMemberRequestContainer),
    threeDotsButtonData: undefined,
  };
};
